import * as React from 'react';

const SelectCheckbox = React.forwardRef<
	HTMLInputElement,
	React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
>((props, ref) => <input ref={ref} {...props} />);

export default SelectCheckbox;
